import type { Recipe } from '../types'
import { bainganBharta } from './recipes/baingan-bharta'
import { caviarAubergines } from './recipes/caviar-aubergines'
import { chiliConCarne } from './recipes/chili-con-carne'
import { cookies } from './recipes/cookies'
import { crepes } from './recipes/crepes'
import { crumbleAuxPommes } from './recipes/crumble-aux-pommes'
import { focaccia } from './recipes/focaccia'
import { fondueSavoyarde } from './recipes/fondue-savoyarde'
import { galetteComtoise } from './recipes/galette-comtoise'
import { gaufres } from './recipes/gaufres'
import { gnocchisALitalienne } from './recipes/gnocchis-a-litalienne'
import { gratinDauphinois } from './recipes/gratin-dauphinois'
import { lasagnesRicottaEpinards } from './recipes/lasagnes-ricotta-epinards'
import { naans } from './recipes/naans'
import { painProtocole } from './recipes/pain-protocole'
import { painsPitaFourPizza } from './recipes/pains-pita-four-pizza'
import { patesChataignes } from './recipes/pates-chataignes'
import { pestoPistaches } from './recipes/pesto-pistaches'
import { pizza } from './recipes/pizza'
import { poolish } from './recipes/poolish'
import { sauceBolognaise } from './recipes/sauce-bolognaise'
import { tarteAuFromageDeMamie } from './recipes/tarte-au-fromage-de-mamie'

export const recipes: Recipe[] = [
  bainganBharta,
  caviarAubergines,
  chiliConCarne,
  cookies,
  crepes,
  crumbleAuxPommes,
  focaccia,
  fondueSavoyarde,
  galetteComtoise,
  gaufres,
  gnocchisALitalienne,
  gratinDauphinois,
  lasagnesRicottaEpinards,
  naans,
  painProtocole,
  painsPitaFourPizza,
  patesChataignes,
  pestoPistaches,
  pizza,
  poolish,
  sauceBolognaise,
  tarteAuFromageDeMamie,
]

export const recipeBySlug = new Map(recipes.map((recipe) => [recipe.slug, recipe]))

export const categories: Array<{ id: Recipe['category']; label: string }> = [
  { id: 'salé', label: 'Salé' },
  { id: 'sucré', label: 'Sucré' },
]
